import type { LotsIdErrors } from '@features/buyer-line-items-pagination/types/id-error-state';

export const countIdErrors = (lotsIdErrors: LotsIdErrors): number => (
  Object.values(lotsIdErrors ?? {}).reduce((total, lotErrors) => (
    total + Object.values(lotErrors ?? {}).reduce((cells, columnKeys) => cells + (columnKeys?.length ?? 0), 0)
  ), 0)
);
